import SearchReducer from './Search.reducer'

export default SearchReducer